import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text } from "react-native";
import { connect } from "react-redux";

import DoctorAvatarWithDetail from "./DoctorAvatarWithDetail";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

class TimelineItem extends React.Component {
  static propTypes = {
    createdAt: PropTypes.instanceOf(Date).isRequired,
    doctor: PropTypes.shape({
      avatarUrl: PropTypes.string,
      fullName: PropTypes.string.isRequired,
      specialities: PropTypes.string.isRequired
    }).isRequired,
    summary: PropTypes.string.isRequired
  };

  render() {
    const { createdAt, doctor, summary, themeColors } = this.props;

    return (
      <>
        <Text
          style={[
            styles.createdAt,
            {
              color: themeColors.darkestPrimary
            }
          ]}
        >
          {I18n.l("time.prixa.default", createdAt)}
        </Text>
        <DoctorAvatarWithDetail
          avatarUrl={doctor.avatarUrl}
          fullName={doctor.fullName}
          specialities={doctor.specialities}
        />
        <Text style={styles.summary}>{summary}</Text>
      </>
    );
  }
}

const styles = StyleSheet.create({
  createdAt: {
    fontSize: 16,
    marginBottom: 20,

    ...fonts.regular
  },
  summary: {
    color: staticColors.grey,
    fontSize: 12,
    marginTop: 5,
    textAlign: 'justify',

    ...fonts.regular
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(TimelineItem);
